import LogRocket from 'logrocket'

export const setupLogrocket = () => {
    if (import.meta.env.PROD) {
        LogRocket.init(import.meta.env.VITE_LOGROCKET_PROJECT_ID, {
            release: '0.0.0',
        })
    }
}
